<template>
	<div class="webview-profile-fitbit">
		<sorry-page v-if="isError" @reload="getData" class="webview-profile-fitbit__inner" />
		<div v-else-if="isMount" class="webview-profile-fitbit__inner">
			<profile-fitbit v-if="isPremium" />

			<!-- 非プレミアム会員向け -->
			<article v-else class="non-member">
				<h1 class="non-member__title">プレミアムサービスのご案内</h1>
				<section class="non-member__inner">
					<h2 class="non-member__subtitle"><img src="@/assets/img/fitbit/title_premium.png" alt="プレミアム 睡眠・心拍データが頭痛ーるで確認できます！"></h2>
					<p class="non-member__text">頭痛ーるがFitbitアプリとのデータ連携をはじめました！日々の健康管理に役立つ睡眠と心拍のデータが取得可能に！</p>
					<p class="non-member__img"><img src="@/assets/img/fitbit/img_report.png" alt="Fitbitレポートイメージ マロも試してみたいニャ～"></p>
					<div class="non-member__recommend">
						<p class="non-member__recommend--text">
							<svg width="9" height="12" viewBox="0 0 9 12" fill="none">
								<path d="M1.00087 0.752155L7.88127 11.1944" stroke="#4C4C4C" stroke-linecap="round"/>
							</svg>
							アンケートに答えると
							<svg width="9" height="12" viewBox="0 0 9 12" fill="none">
								<path d="M7.87999 0.752155L0.999585 11.1944" stroke="#4C4C4C" stroke-linecap="round"/>
							</svg>
							<br>
							プレミアムプラン付きFitbitが購入できます！
						</p>
						<a href="https://docs.google.com/forms/d/e/1FAIpQLScLe5HESD-ungEVT_Fb4wS5wwke1-GtZzWXnTkzBNy2_ZlFFw/viewform" target="_blank" rel="noopener noreferrer" class="non-member__recommend--button"><img src="@/assets/img/fitbit/btn.png" alt="プレミアムxFitbit 詳しくはこちら"></a>
					</div>
					<a href="native://openFitbitInfo" class="non-member__howto"><img src="@/assets/img/fitbit/bnr.png" alt="Fitbitとデータ連携して睡眠・心拍を確認！"></a>
				</section>
			</article>
		</div>
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_USER_DATA, SET_PREMIUM_TYPE, SET_IS_WEBVIEW } from '../store/modules/common/mutation-types'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'

// Compornents
import ProfileFitbit from '@/components/Organisms/ProfileFitbit'
import SorryPage from '@/views/SorryPage'

export default {
	name: 'WebviewProfileFitbit',
	components: {
		ProfileFitbit,
		SorryPage
	},
	data () {
		return {
			isError: false,
			isMount: false,
			userId: null,
			userToken: null,
			isPremium: false
		}
	},
	created () {
		// OnsenUIのbody要素に付与されているstyleを打ち消す
		const style = document.body.getAttribute('style')
		document.body.setAttribute('style', `${style} position: inherit; overflow: auto;`)

		// storeにwebviewフラグを立てる
		this.SET_IS_WEBVIEW(true)
		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', state)
			this.isError = true
		} else {
			// URLパラメータからユーザーID、ユーザートークンを取得する
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// APIリクエスト処理
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userData', 'premiumType'])
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_USER_DATA, SET_PREMIUM_TYPE, SET_IS_WEBVIEW]),

		// データ取得処理
		getData () {
			// 状態の初期化
			this.isError = false
			this.isMount = false

			// NOTE: ユーザー情報と課金タイプを取得したら子コンポーネントをマウントする
			const SET_USER_DATA = this.SET_USER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_PREMIUM_TYPE = this.SET_PREMIUM_TYPE({
				user_id: this.userId,
				user_token: this.userToken
			})
			Promise.all([SET_USER_DATA, SET_PREMIUM_TYPE]).then(res => {
				// console.log('userData: ', this.userData)
				// console.log('premiumType: ', this.premiumType)
				this.isMount = true
				this.isPremium = this.premiumType && this.premiumType.premium_type_code > 1
			}).catch(error => {
				// ユーザー情報取得エラー
				console.log('userData error: ', error)
				this.isError = true
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止
$spacing-5: 0.312rem;
$spacing-12: 0.75rem;
$spacing-15: 0.937rem;
$spacing-24: 1.5rem;

$color-background: #EBEBEB;

.webview-profile-fitbit {
	width: 100%;
	height: auto;
	background-color: $color-background;
	padding: $spacing-10 0 $spacing-20;

	// 無料会員
	.non-member {
		position: relative;
		margin: 0 $spacing-10;
		padding: $spacing-10 0 $spacing-6;
		font-family: $lp-family-primary;
		color: $text-primary;
		background-color: $background-primary;
		border-radius: $spacing-15;

		&__title {
			margin: 0 $spacing-6;
			padding: 0 0 $spacing-8;
			font-family: $lp-family-primary;
			font-size: $font-size-12;
			text-align: center;
			border-bottom: 1px solid $primary;
		}

		&__subtitle {
			padding: $spacing-5 $spacing-10 0;
			margin: 0;

			& > img {
				display: block;
				width: 100%;
			}
		}

		&__text {
			margin: $spacing-14 0 0;
			padding: 0 $spacing-20;
			font-size: $font-size-14;
			text-align: justify;
		}

		&__img {
			margin: $spacing-12 0 0;

			& > img {
				display: block;
				width: 100%;
			}
		}

		&__recommend {
			margin: $spacing-12 auto 0;
			padding: 0 $spacing-20;

			&--text {
				margin: 0 auto;
				font-size: $font-size-12;
				text-align: center;
			}

			&--button {
				position: relative;
				display: block;
				width: 100%;
				margin: $spacing-8 auto 0;

				& > img {
					display: block;
					width: 100%;
				}
			}
		}

		&__howto {
			display: block;
			margin: $spacing-24 $spacing-6 0;
			text-decoration: none;

			& > img {
				display: block;
				width: 100%;
			}
		}
	}
}
</style>
